import React, { Component, Fragment } from "react";
import classnames from "classnames";
import "../../assets/scss/components/sidebar/sidebar.scss";
import EventEmitter, { Events } from "../../services/eventemitter";

import SideMenuContent from "./sidemenu";
import SidebarHeader from "./sidebarHeader";
import templateConfig from "../../templateConfig";
import Customizer from "../../components/customizer/customizer";
import { LoginResponse, UnSentChatMDL } from "../../models";
import UnsentChatPopup from "../../views/unsentchatpopup/chat-popup";
import { wglcsApiService } from "../../services/WglcsApiService";
import { cookieService } from "../../services/CookieService";
import { DetectEnvironment } from "../../EnvironmentSettings";
import { utils } from "../../utils";
// import Cookies from "universal-cookie";
interface props {
    toggleSidebarMenu: any;
    sidebarState: string;
    handleSidebarSize: (size: string) => void;
    handleLayout: (layout: string) => void;
    sideBarExpandCallback: any;
    sideBarButton: () => void;
    maskLayout: (state: boolean) => void;

}

interface state {
    color: string;
    imgurl: string;
    collapsedSidebar: boolean;
    userData: LoginResponse;
    hasUnsentChats: boolean;
    width: any;
    IsCompact: boolean;
    collapsedSidebar2: boolean;
    unsentChats: UnSentChatMDL[];
    sideBarClass: string,
    customheight: number,
    isSideBarExpand: boolean
}
// const cookies = new Cookies();
class Sidebar extends Component<props, state> {
    constructor(props) {
        super(props);
        let userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        this.state = {
            collapsedSidebar: templateConfig.sidebar.collapsed,
            width: window.innerWidth,
            userData: userData,
            hasUnsentChats: false,
            // color: cookies.get("sidebar-color"),
            color: cookieService.getElectronCookies("sidebar-color"),
            // imgurl: cookies.get("sidebar-imgurl"),
            imgurl: cookieService.getElectronCookies("sidebar-imgurl"),
            IsCompact: true,
            collapsedSidebar2: true,
            unsentChats: [],
            sideBarClass: "app-sidebar",
            customheight: 30,
            isSideBarExpand: false
        };

        // EventEmitter.on(Events.removeMarginOfSideBar, this.removeMargin)
    }

    // removeMargin = (Flag) => {
    //     if (Flag) {
    //         this.setState({ sideBarClass: "app-sidebar remove-margin" })
    //     }
    //     else {
    //         this.setState({ sideBarClass: "app-sidebar set-margin" })
    //     }
    // }

    updateWidth = () => {
        if (window.innerWidth <= 991) this.setState({ collapsedSidebar: false });
        else this.setState({ collapsedSidebar: true });
        this.setState((prevState) => ({
            width: window.innerWidth,
        }));
    };

    handleCollapsedSidebar = (collapsedSidebar: boolean) => {
        this.setState({ IsCompact: collapsedSidebar, collapsedSidebar: false, collapsedSidebar2: collapsedSidebar });
    };

    UnsentPopup = async () => {
        let userData = this.state.userData;
        if (userData) {
            for (const userInterface of userData.interfaces) {
                if (userInterface.interfaceName === "Supervisor Alert") {
                    setInterval(this.unsentChatInterval, 500000);
                } else if (userInterface.interfaceName === "QA Alert") {
                    setInterval(this.unsentChatInterval, 1000000);
                }
            }
        }
    };
    unsentChatInterval = async () => {
        let data: UnSentChatMDL[] =
            (await wglcsApiService.getcountofnotsentchatsofuserschatids(this.state.userData.userLoginData.empCompId, 5)).data?.data ?? [];
        this.setState({ unsentChats: data });
        if (data.length > 0) {
            this.unsentChatCondition();
        }
    };
    unsentChatCondition = (e = true) => {
        this.setState({ hasUnsentChats: e });
    };
    componentDidMount() {
        this.getPersistedLayout()
        var sideBarSetting = cookieService.getElectronCookies("is-sidebar-expanded");
        if (sideBarSetting == null || sideBarSetting == undefined || sideBarSetting == "false") {
            this.sidebarCollapse()
        }
        else {
            this.sidebarExpand()
        }

        this.UnsentPopup();
        window.addEventListener('scroll', this.handleScroll);

        if (window.innerWidth > 1199) {

        }
        else {
            this.setState({ customheight: window.innerHeight - 250 })
        }

    }
    handleScroll = () => {
        document.querySelector("#change-class")?.classList.add('add-scroll-top');
    }

    componentWillUnmount() {
        if (window) {
            window.removeEventListener("resize", this.updateWidth, false);
        }
    }

    handleMouseEnter = () => {
        if (!this.state.IsCompact) {
            this.setState((prevState) => ({
                collapsedSidebar2: false,
            }));
        }
    };

    handleMouseLeave = () => {
        // if (!this.state.IsCompact) {
        this.setState((prevState) => ({
            collapsedSidebar2: true,
        }));
        // }
    };



    sidebarBgColor = (color: string) => {
        // cookies.set("sidebar-color", color);
        cookieService.setElectronCookies("sidebar-color", color);
        this.setState({ color: color });
        EventEmitter.emit(Events.navColor, color);
    };

    sidebarImageUrl = (imgurl: string) => {
        // cookies.set("sidebar-imgurl", imgurl);
        cookieService.setElectronCookies("sidebar-imgurl", imgurl);
        this.setState({ imgurl: imgurl });
    };

    sidebarExpand = () => {
        this.setState({ isSideBarExpand: true, sideBarClass: 'app-sidebar sidebar-expand' })
        this.props.sideBarExpandCallback('expand-wrapper')
        cookieService.setElectronCookies("is-sidebar-expanded", true);
    }

    sidebarCollapse = () => {
        this.setState({ isSideBarExpand: false, sideBarClass: 'app-sidebar' });
        this.props.sideBarExpandCallback('')
        cookieService.setElectronCookies("is-sidebar-expanded", false);
    }

    persistLayout = (value) => {
        cookieService.setElectronCookies("LayoutMode", value)
        EventEmitter.emit(Events.changelayOutMode, value);

    };

    handleLayout = (layout: string) => {
        this.props.handleLayout(layout);
    };

    getPersistedLayout = () => {
        const layoutModeValue = cookieService.getElectronCookies("LayoutMode")
        if (layoutModeValue != undefined) {
            this.changeMode(layoutModeValue)
        }
        else {
            this.changeMode('layout-light')
        }
    };


    changeMode = (value) => {
        this.handleLayout(value);
        this.toggleDarkMode(value)
        this.persistLayout(value);
    };

    toggleDarkMode = (layoutMode) => {
        if (layoutMode == 'layout-dark') {
            var darkModeLink = document.getElementById("darkmodeCss");

            if (darkModeLink == null) {
                this.loadCssIntoDom("darkmodeCss", "/css/" + DetectEnvironment.config.REACT_APP_DARKMODE_STYLESHEET);
            }
        }
        else {
            var darkModeLink = document.getElementById("darkmodeCss");

            if (darkModeLink != null) {
                document.head.removeChild(darkModeLink);
            }
        }
    };

    loadCssIntoDom = (id: string, path: string) => {
        var existingElement = document.getElementById(id);

        if (existingElement != null) {
            return;
        }

        var link = document.createElement("link");

        link.setAttribute("id", id);
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = process.env.PUBLIC_URL + path;
        document.head.appendChild(link);
    }

    sideBarButton = () => {

        this.props.sideBarButton();
        this.props.maskLayout(false);
    };

    getSideBarArrowBg = () => {
        if(utils.isDepLiveChat()){
            return {backgroundColor: "#1e94d2", border: "1px solid #1e94d2"}
        }
    }

    render() {
        return (
            <Fragment>
                {this.state.hasUnsentChats && (
                    <UnsentChatPopup
                        data={this.state.unsentChats}
                        unsentChatCondition={(e) => {
                            this.unsentChatCondition(e);
                        }}
                    />
                )}
                <div
                    data-active-color="white"
                    id="change-class"
                    data-background-color={this.state.color === "" ? templateConfig.sidebar.backgroundColor : this.state.color}
                    className={classnames(
                        `${this.state.sideBarClass}`,
                        {
                            "": this.state.collapsedSidebar2,
                            collapsed: this.state.collapsedSidebar2,
                        },
                        {
                            "hide-sidebar": this.state.width < 1199 && this.props.sidebarState === "close",
                            "": this.props.sidebarState === "open",
                        }
                    )}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.state.width > 991 ? this.handleMouseLeave : undefined}
                >
                    <SidebarHeader sidebarBgColor={this.state.color} />
                    <span onClick={this.sideBarButton} className="cross-icon-menu"><i className="fa-light fa-xmark"></i></span>

                    {!this.state.isSideBarExpand ? <span className="sidebar-arrow" style={this.getSideBarArrowBg()} onClick={() => this.sidebarExpand()}>

                        <i className="far fa-chevron-right"></i>
                    </span> :
                        <span className="sidebar-arrow" style={this.getSideBarArrowBg()} onClick={() => this.sidebarCollapse()}>

                            <i className="far fa-chevron-left"></i>
                        </span>

                    }

                    <div className="sidebar-content"
                        style={{ height: this.state.customheight }}
                    >
                        <SideMenuContent
                            toggleSidebarMenu={this.props.toggleSidebarMenu}
                        />

                    </div>
                    <div className="darkview">
                        <button onClick={() => this.changeMode('layout-light')} className="light-view"><i className="fa-solid fa-brightness"></i> <span className="menutext">Light</span></button>
                        <button onClick={() => this.changeMode('layout-dark')} className="dark-view"><i className="fa-solid fa-moon"></i> <span className="menutext">Dark</span></button>
                    </div>

                    {templateConfig.sidebar.backgroundImage ? (
                        this.state.imgurl === "" ? (
                            <div
                                className="sidebar-background"
                                style={{ backgroundImage: "url('" + templateConfig.sidebar.backgroundImageURL + "')" }}
                            ></div>
                        ) : (
                            <div className="sidebar-background" style={{ backgroundImage: "url('" + this.state.imgurl + "')" }}></div>
                        )
                    ) : this.state.imgurl === "" ? (
                        <div className="sidebar-background"></div>
                    ) : (
                        <div className="sidebar-background" style={{ backgroundImage: "url('" + this.state.imgurl + "')" }}></div>
                    )}

                </div>
                <Customizer
                    sidebarBgColor={this.sidebarBgColor}
                    sidebarImageUrl={this.sidebarImageUrl}
                    handleSidebarSize={this.props.handleSidebarSize}
                    handleLayout={this.props.handleLayout}
                    handleCollapsedSidebar={this.handleCollapsedSidebar.bind(this)}
                />
            </Fragment>
        );
    }
}

export default Sidebar;
